<h3>Processed</h3>

<div class="container">
  <div class="item-list">
    <div *ngIf="processedImages.length < 1">Empty</div>
    <div *ngFor="let image of processedImages" class="item">
      <span>{{ image.state }}</span>
      <img [alt]="image.id" [src]="image.path" />
      <button (click)="loadFile(image)">Load</button>
    </div>
  </div>

  <div *ngIf="selectedImage" class="loaded-item">
    <nw-bounding-box-visualizer *ngIf="selectedImage" [imageUrl]="selectedImage.path"
      [detectedObjects]="detectedObjects" [loading]="loading"
      (change)="saveCustomDetection($event)"></nw-bounding-box-visualizer>
    <div style="margin-left: 64px">
      <div class="label-list">
        <h3>Detected Labels</h3>
        <ul>
          <li *ngFor="let entry of labelCount | keyvalue">
            {{ entry.key }}: {{ entry.value }}
          </li>
        </ul>
      </div>

      <div>
        <textarea [style.width.px]="500" [style.height.px]="500">{{ stringify(detectedObjects) }}</textarea>
      </div>
    </div>
  </div>
</div>